(function () {
    'use strict';

    angular
        .module('adm')
        .controller('AdmDepartmentEditController', AdmDepartmentEditController);

    AdmDepartmentEditController.$inject = ['$uibModalInstance', 'AdmService', 'department'];

    function AdmDepartmentEditController($uibModalInstance, AdmService, department) {
        var vm = this;

        vm.ok              = ok;
        vm.cancel          = cancel;
        vm.update          = update;
        vm.department      = {};

        angular.copy(department, vm.department);

        activate();

        function activate() {
        }

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        function update() {
            vm.query = {};
            vm.query['id']                  = vm.department.id;
            vm.query['name']                = vm.department.name;
            vm.query['description']         = vm.department.description;
            AdmService.updateDepartment(vm.query).then(function(response){
                alertify.notify('Department is successfully updated', 'success', 3);
                department.name = vm.department.name;
                department.description = vm.department.description;
                vm.cancel();
            }).catch(function(err) {
                alertify.notify('An error occurred on update', 'error', 3);
            });
        }

    }

})();